import config from "../config.js";
import RequestManager from "./request.js";

export default class Values {

    static async GetClaims(token) {
        if (token == null) {
            console.warn("TOKEN == null");
            return Promise.resolve({});
        }
        else {
            let urlGetClaims = `${config.urlBackEnd}Values/GetClaims`;
            return await RequestManager.get(urlGetClaims)
                .then(response => {
                    console.log("Infos token : ", response);
                    return Values.normaliserClaims(response);
                })
                .catch(error => { console.error(" error on Values.GetClaims() ", error); return {}; });
        }
    }

    // Le backend renvoie les claims indexes par leur TYPE JWT brut (ToDictionary(c => c.Type),
    // serialise avec ProcessDictionaryKeys=false -> cles conservees telles quelles). L'email est
    // ecrit via new Claim(ClaimTypes.Email, ...) donc sa cle est l'URI complet
    // "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress" (et non "email").
    // Tous les consommateurs lisent claims.email : on garantit cet alias, quel que soit le nom
    // exact de la cle cote backend. Idempotent si "email" est deja present (anciens tokens).
    static normaliserClaims(claims) {
        if (!claims || typeof claims !== 'object') {
            return {};
        }
        const resultat = { ...claims };
        const trouverValeur = (predicat) => {
            for (const [cle, valeur] of Object.entries(claims)) {
                if (typeof valeur === 'string' && predicat(cle.toLowerCase(), valeur)) {
                    return valeur;
                }
            }
            return undefined;
        };
        if (!resultat.email) {
            resultat.email =
                trouverValeur(cle => cle === 'email' || cle.endsWith('emailaddress'))
                ?? trouverValeur((cle, valeur) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(valeur))
                ?? "";
        }
        return resultat;
    }

    static async GenerateTokenClient(client) {
        if (client == null) {
            console.warn("CLIENT == null");
            return Promise.resolve({});
        }
        else {
            try {
                const response = await RequestManager.post(`${config.urlBackEnd}Values/GenerateTokenClient`, {
                    ADELI: client.ADELI,
                    nom: client.nom,
                    prenom: client.prenom,
                    adresse1: client.adresse1,
                    adresse2: client.adresse2,
                    tel: client.tel,
                    email: client.email
                });
                return response;
            } catch (error) {
                console.error("Erreur lors de la génération du token :", error);
                throw error;  
            }
        }
    }

}
